import { useEffect, useState } from "react";
import apiService from "services/apiService";

const useMedicalSpecialties = () => {
    const [medSp, setMedSp] = useState(null);

    useEffect(() => {

        let isMounted = true;

        const fetchData = async () => {
            try {
                console.log("Fetching medical specialties...");
                const response = await apiService.get("/moh_manager/all/medSpecialties");

                if (isMounted) {
                    console.log("API Response:", response);
                    setMedSp(response?.data ?? []); // Set to empty array if null
                }
            } catch (error) {
                console.error("Error fetching medical specialties:", error);
            }
        };

        fetchData();

        return () => {
            isMounted = false;
        };
    }, []);

    return medSp;
};

export default useMedicalSpecialties;
